// Recursive dependency, do not move to index.ts
export enum Theme {
  Main,
  Auth,
  Profile,
}
